
import {finalize} from 'rxjs/operators';
import { assign } from 'lodash';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

import { CLAccount } from './account';
import { CLAccountService, CLAccountFilter } from './account.service';
import { CLAccountFilterDialogComponent } from './account-filter-dialog.component';
import { NotifierService, DialogService } from '../../ui';

const FILTER_KEY = 'client-accounts.filter';

@Component({
  templateUrl: './account-list.component.html',
})
export class CLAccountListComponent implements OnInit {

  filter: CLAccountFilter;

  perPage = 10
  accountsCount: number = 0
  accounts: CLAccount[]

  constructor(
    private accountService: CLAccountService,
    private router: Router,
    private notifier: NotifierService,
    private dialogService: DialogService
  ) { }

  ngOnInit() {
    this.filter = new CLAccountFilter();

    // Load filter from localStorage
    if(window.localStorage) {
      try {
        let data = window.localStorage.getItem(FILTER_KEY);

        let filterData = JSON.parse(data);

        assign(this.filter, filterData);
      }
      catch(err) {
      }
    }
    
    this.fetch();
  }

  fetchMore() {
    this.fetch(this.accounts.length);
  }

  private fetch(offset = 0, limit = this.perPage, replace = false) {
    this.notifier.startProgress();

    this.filter.offset = offset;
    this.filter.limit = limit;

    this.accountService
      .accounts(this.filter).pipe(
      finalize(() => this.notifier.endProgress()))
      .subscribe((result) => {
        // Replace
        if (replace) {
          this.accounts = result.accounts;
        }
        // Append
        else {
          this.accounts = [...this.accounts || [], ...result.accounts];
        }

        this.accountsCount = result.accountsCount;
      });
    
    // Save filter to localStorage
    if(window.localStorage) {
      window.localStorage.setItem(FILTER_KEY, JSON.stringify(this.filter));
    }
  }

  showCLAccount(account: CLAccount, event: Event) {
    let nodeName = (<Element>event.target).nodeName;

    if (nodeName === 'TD' || nodeName === 'TR') {
      this.router.navigate(['shares-ledger', 'client-accounts', account.id]);
    }
  }

  applyFilter() {
    this.dialogService.show({
      component: CLAccountFilterDialogComponent,
      props: {

        filter: this.filter,

        onClose: () => {
          this.dialogService.hide();
        },

        onApply: (filter: CLAccountFilter) => {
          this.fetch(0, this.perPage, true);
        }
      }
    });
  }

  clearSearch() {
    this.filter.search = '';

    this.fetch(0, this.perPage, true);
  }

  delete(account: CLAccount) {
    this.dialogService
      .confirmDelete('Voulez-vous supprimer ce compte client?')
      .subscribe((result) => {
        if (!result) {
          return;
        }

        this.notifier.startProgress();

        this.accountService
          .delete(account.id)
          .subscribe((id) => {
            this.notifier.success('Compte client supprimé avec succès');

            this.fetch(0, this.accounts.length, true);
          }, (err) => {
            this.notifier.endProgress();
          });
      });
    
    return false;
  }
}
